import { useMemo } from 'react';

import { createTheme, CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import { FONTS_NAME } from './fonts';
import componentsOverride from './overrides';
import Palette from './palette';
import { presetColors } from './presetColors';
import Typography from './typography';

interface ThemeCustomizationProps {
    children: React.ReactNode;
}

export default function ThemeCustomization({ children }: ThemeCustomizationProps) {
    const palette = Palette('light');
    const tipog = Typography(FONTS_NAME);

    const theme = useMemo(() => {
        const base = createTheme({
            breakpoints: {
                values: { xs: 0, sm: 768, md: 1024, lg: 1266, xl: 1536 },
            },
            direction: 'ltr',
            mixins: { toolbar: { minHeight: 60, paddingTop: 8, paddingBottom: 8 } },
            presetColors,
            palette: palette.palette,
            typography: tipog,
        });

        return createTheme(base, {
            components: componentsOverride(base),
        });
    }, [palette, tipog]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </StyledEngineProvider>
    );
}
